import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'

import * as EventTicketsSelectors from './event-tickets.selectors'
import { BaseEventTicketsFacade } from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.facade'
import { EventTicketsState } from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.reducer'

@Injectable({
  providedIn: 'root',
})
export class EventTicketsFacade extends BaseEventTicketsFacade {
  selectedEventTicketProfileMismatch$ = this.store.select(EventTicketsSelectors.selectedEventTicketProfileMismatch)

  constructor(protected store: Store<EventTicketsState>) {
    super(store)
  }
}
